import "./components/MobileMenu";

if (document.querySelector(".lux-mobile-menu")) {
    import("./components/MobileMenuExpand.js");
}

if (document.querySelector(".waitlist-email")) {
    import("./components/shop/addToWaitlist");
}

if (document.querySelector("[data-countdown-ends-at]")) {
    import("./components/countdowns/countdown-module.js").then(({ init }) =>
        init(),
    );
}

import "./components/shop/brand-discount";
import "./components/shop/brands";
import "./components/shop/cart";

if (document.querySelector(".lux-header-button.favorites")) {
    import("./components/shop/favorites.js").then(({ default: favorites }) => {
        window.favorites = favorites;
        favorites.init();
    });
}

if (document.getElementById("lux-modal-edit-favorites")) {
    import("./components/shop/edit-favorites.js").then(({ init }) => init());
}

if (document.getElementById("klarna-wrapper")) {
    import("./components/payments/klarna-token.js").then(({ init }) => init());
}

if (document.getElementById("form-container")) {
    import("./components/rating-page.js");
}

if (document.querySelector('input[name="zipcode"]')) {
    import("./components/checkout/post-code-lookup.js");
}

if (document.querySelector(".btn-see-more-blogposts[data-load-more-url]")) {
    import("./components/blog-load-more.js");
}

if (document.getElementById("btn-load-cookie-script")) {
    import("./components/gdpr-cookie-consent.js");
}

if (document.querySelector(".lux-membership-list .toggle")) {
    import("./components/subscription/agreement-list.js");
}

if (document.querySelector(".swiper-membership-progression .swiper-wrapper")) {
    import("./components/membership-journeys/show-progress.js");
}

if (document.querySelector(".section-memberships-hero.with-banner")) {
    import("./components/membership/membership-hero-banner.js");
}

if (
    document.querySelector(
        ".section-memberships.choose-membership .lux-membership .add-sub",
    )
) {
    import("./components/membership/memberships-fixed.js");
}

if (document.getElementById("lux-toast-info")) {
    import("./components/lux-popups/info-toast.js");
}

if (document.querySelector(".page-cart")) {
    import("./components/shop/cart-page-reload-on-change.js");
}

import "./components/checkout/scroll-to-summary";
import "./components/orders/products-oos-modal";
import "./components/menu/desktop-overlay";
import "./components/shop/footer";
import "./components/shop/campaignTagRotator";
import "./components/shop/quick-buy-btn";
import "./components/shop/promo-box";
import "./components/shop/youtube-videos";

if (import.meta.hot) {
    import.meta.hot.accept();
}
